// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessDisplay_container__EbFvo","header":"SuccessDisplay_header__qhYQU","icon":"SuccessDisplay_icon___w926"};